import { useHttp } from './http';

const http = useHttp('radar_settings');

export default {
  get: () => http.get(),
  update: settings => http.put('', settings),
};
